import { render, staticRenderFns } from "./ILRPopup.vue?vue&type=template&id=1b46d110&lang=pug"
import script from "./ILRPopup.vue?vue&type=script&lang=ts"
export * from "./ILRPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports